import * as React from 'react'
import type { CommonDeps } from '../../base/CommonDeps'
import type { SharedProps } from './SharedProps'
import { ViewFlowItem } from './ViewFlowItem'
import type { UnitData } from '../../../../shared/domain/units/types.no-deps'
import type { FlowItem } from '../../../../shared/domain/viewableReports/types.no-deps'

interface Props extends SharedProps {
    deps: CommonDeps
    items: FlowItem[]
    unitData?: UnitData
}

export class ViewFlowItems extends React.Component<Props> {
    public render = () => {
        return (
            <div className="AppCore__report__Answers">
                {this.props.items.map((item) => (
                    <ViewFlowItem
                        {...this.props}
                        key={item.type === 'element' ? item.element.id : item.answer.timestamp.toString()}
                        item={item}
                    />
                ))}
            </div>
        )
    }
}
